import { fontSizeTypeMixin } from "./fontSizeTypeMixin";
import { fontWeightTypeMixin } from "./fontWeightTypeMixin";
import { lineHeightTypeMixin } from "./lineHeightTypeMixin";
import { inlineMediaQueryMixin } from "./inlineMediaQueryMixin";
/** @mixin fontTypeMixin */

/**
 * Adds styling for font attributes.
 *
 * @example
 * import { fontTypeMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *    ${fontTypeMixin}
 * `';
 *
 * <Component fontType="h1">H1 styling</Component>
 * <Component fontType={{ default: 'h1', sm_lte: 'h2' }}>Responsive styling</Component>
 *
 * @method
 * @param {object} props
 * @param {string|object} [props.fontType] - The font type string or an object that maps breakpoints
 *    to font type strings
 * @return {Interpolation}
 */

export var fontTypeMixin = function fontTypeMixin(props) {
  if (!props.fontType) {
    return "";
  }

  return inlineMediaQueryMixin("fontType", function (mediaProps) {
    return [fontWeightTypeMixin(mediaProps), fontSizeTypeMixin(mediaProps), lineHeightTypeMixin(mediaProps)];
  })(props);
};